import { motion } from "framer-motion";
import { Eyebrow, PrimaryButton, GhostButton } from "@/components/ui-bits";

const CapacityHero = () => {
  return (
    <section data-testid="capacity-hero" aria-labelledby="capacity-hero-heading" className="relative overflow-hidden bg-white">
      <div className="grid lg:min-h-[560px] lg:grid-cols-12">
        <div className="container-30 flex items-center py-16 sm:py-20 lg:col-span-6 lg:py-24 lg:pr-0">
          <div className="max-w-xl">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}>
              <Eyebrow>Transportation Options</Eyebrow>
            </motion.div>
            <motion.h1
              id="capacity-hero-heading"
              data-testid="capacity-hero-headline"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-4xl font-black leading-[1.02] tracking-tight text-[#191c1e] sm:text-5xl lg:text-[2.5rem] xl:text-6xl"
            >
              FLEXIBLE TRANSPORTATION. BUILT AROUND YOUR FREIGHT.
            </motion.h1>
            <motion.p
              data-testid="capacity-hero-subcopy"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg"
            >
              Transportation solutions designed around the requirements of your freight, from full-size dry van
              transportation to smaller, time-sensitive shipments.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center"
            >
              <PrimaryButton to="/request-a-quote" testid="capacity-hero-primary-cta" className="w-full sm:w-auto">
                REQUEST A QUOTE
              </PrimaryButton>
              <GhostButton to="/services" testid="capacity-hero-secondary-cta" className="w-full sm:w-auto">
                EXPLORE OUR SERVICES
              </GhostButton>
            </motion.div>
          </div>
        </div>
        <div className="relative h-72 sm:h-96 lg:col-span-6 lg:h-auto">
          <motion.img
            src="/assets/capacity-hero.webp"
            alt="A 30 NORTH branded 53-foot tractor-trailer and Sprinter van at a modern Ontario logistics facility"
            data-testid="capacity-hero-image"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-y-0 left-0 hidden w-24 bg-gradient-to-r from-white to-transparent lg:block" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
};

export default CapacityHero;
